<template>
<div>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Configurações dos Tickets</h4>
    </div>
    <div class="card-content">
      <div class="form-group">
        <div>
          <p class="category">
            O <strong>código de barra</strong> será manual ou automático?
          </p>
          <p-radio
            inline
            v-model="project.ticket.automaticBarcode"
            label="true"
          >Automático
          </p-radio>
          <p-radio
            inline
            v-model="project.ticket.automaticBarcode"
            label="false"
          >Manual
          </p-radio>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'TicketsConfigForm',
  computed: {
    ...mapGetters('project', ['validations']),
    project: {
      get () {
        return this.$store.state.project.one
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/Project/TicketsConfigForm.vue